import styled, { css } from 'styled-components';

import { size } from '../../layout/helpers';
import { ButtonReset } from '../../layout/reset';
import { Foldout } from '../Foldout/wrapper';

export const openButtonSize = 4;

interface WrapperProps {
  $dynamicSize?: boolean;
}

export const Wrapper = styled.div<WrapperProps>`
  position: relative;
  width: ${($dynamicSize) => ($dynamicSize ? 'auto' : size(openButtonSize))};
  height: ${size(openButtonSize)};
  //margin: calc((${size(openButtonSize)} - 1.125rem) / -2);

  ${Foldout} {
    margin-top: ${size(-0.5)};
  }
`;

interface OpenButtonProps {
  $style?: 'overlay';
  $dynamicSize?: boolean;
}

export const OpenButton = styled(ButtonReset)<OpenButtonProps>`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${($dynamicSize) => ($dynamicSize ? 'auto' : size(openButtonSize))};
  height: ${size(openButtonSize)};
  font-size: ${size(3)};
  color: var(--c-accent-fg);
  border-radius: 50%;
  z-index: 1;

  &::before {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    width: ${($dynamicSize) => ($dynamicSize ? 'auto' : size(openButtonSize))};
    height: ${size(openButtonSize)};
    margin-top: ${size((openButtonSize / 2) * -1)};
    margin-left: ${size((openButtonSize / 2) * -1)};
    border-radius: 50%;
    background-color: var(--c-accent-bg);
    transform: scale(0);
    transition: transform 300ms cubic-bezier(0.47, 1.64, 0.41, 0.8);
    z-index: -1;
  }

  &:hover {
    &::before {
      transform: scale(1);
    }
  }

  ${({ $style }) =>
    $style === 'overlay'
      ? css`
          color: var(--c-base-fg);

          &::before {
            background-color: rgba(var(--c-overlay-rgb), 0.5);
            transform: scale(1);
            transition: opacity 200ms ease;
          }

          &:hover {
            &::before {
              opacity: 0.8;
            }
          }
        `
      : undefined}
`;
